import type { AxiosRequestConfig } from "axios";
import type { IPaginated, IRepositoryOptions } from "@/types/common";
import type { IClient } from "@/types/users-clients";
import { BaseRepository } from "../BaseRepository";
import type { ClientsService } from "./service";
import type {
  IDeleteClientRequest,
  IGetClientProfileByUserIdRequest,
  IGetClientsRequest,
  IUpdateClientPropertyRequest,
  IUpdateClientRequest,
} from "./types";

export class ClientsRepository extends BaseRepository {
  constructor(
    private readonly service: ClientsService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(
    p: IGetClientsRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPaginated<IClient>> {
    const response = await this.handleRequest(this.service.getAll, p, c);
    return response.data;
  }

  async deleteClient(
    p: IDeleteClientRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    const response = await this.handleRequest(this.service.deleteClient, p, c);
    return response.data;
  }

  async updateClient(
    p: IUpdateClientRequest,
    c?: AxiosRequestConfig,
  ): Promise<IClient> {
    const response = await this.handleRequest(this.service.updateClient, p, c);
    return response.data;
  }

  async updateClientProperty(
    p: IUpdateClientPropertyRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    const response = await this.handleRequest(
      this.service.updateClientProperty,
      p,
      c,
    );
    return response.data;
  }

  async getProfileByUserId(
    p: IGetClientProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): Promise<IClient> {
    const response = await this.handleRequest(
      this.service.getProfileByUserId,
      p,
      c,
    );
    return response.data;
  }
}
